import {
  BotActionTypes,
  botFillActionType,
  saveBotActionType,
  exploreBotActionType,
  changeSelectedBotActionType,
  buildBotActionType,
} from '../../model/bot/actions';
import { createActions } from '../../helpers/actionsHelper';
import { Bot } from '../../model/bot/types';

export const changeSelectedBotAction = createActions<BotActionTypes, string, string>(changeSelectedBotActionType);

export const exploreBotAction = createActions<BotActionTypes, string, string>(exploreBotActionType);

export const fillBotAction = createActions<BotActionTypes, {}, Bot[]>(botFillActionType);

export const saveBotAction = createActions<BotActionTypes, Bot, Bot>(saveBotActionType);

export function buildBot(): BotActionTypes {
  return {
    type: buildBotActionType,
    payload: {},
  };
}